// Mock data para la landing page del libro
export const bookData = {
  title: "Tu Nombre en el Campo",
  subtitle: "Marca Personal para Entrenadores de Fútbol Noveles",
  authors: [
    {
      name: "Edgar Merino Vidangossy",
      photo: "https://customer-assets.emergentagent.com/job_page-book/artifacts/fg3f1cvs_IMG_2155.jpeg",
      bio: "Periodista de profesión con múltiples Másters en Gestión Deportiva, Marketing Deportivo y Bigdata Deportivo. Coach en Programación Neurolingüística y experto en Personal Branding. Director de Solo Cracks, agencia líder en Latinoamérica de fútbol femenino, y director de Ikons Agency. Mentor de agentes de futbolistas y docente de Gestión Deportiva en Johan Cruyff Institute.",
      credentials: [
        "Máster en Gestión Deportiva",
        "Máster en Marketing Deportivo",
        "Máster en Bigdata Deportivo",
        "Coach en Programación Neurolingüística",
        "Experto en Personal Branding"
      ],
      highlights: [
        {
          title: "Docente de Gestión Deportiva",
          description: "Johan Cruyff Institute y de Agentes de Futbolistas en ITTI Sports Institute"
        },
        {
          title: "Conferencista Internacional",
          description: "Más de 70 eventos alrededor del mundo"
        }
      ]
    },
    {
      name: "Edgardo Merino Pantoja",
      photo: "https://customer-assets.emergentagent.com/job_page-book/artifacts/844cn5hf_374207d4-5ac8-4c15-b109-10f259e8259f.jpeg",
      bio: "Maestro en Planeación y Desarrollo Educativo, Magíster en Educación a Distancia, Master en Bigdata Deportiva, Master en Marketing Deportivo, Licenciado en Educación y Profesor de Estado en Matemática y Computación, se ha desempeñado en diversas instituciones de educación superior. En el plano deportivo tiene el título de Entrenador de Fútbol Infantil, Entrenador de Fútbol Femenino y diversas especializaciones en dirección deportiva.",
      credentials: [
        "Maestro en Planeación y Desarrollo Educativo",
        "Magíster en Educación a Distancia",
        "Master en Bigdata Deportiva",
        "Master en Marketing Deportivo",
        "Licenciado en Educación",
        "Profesor de Estado en Matemática y Computación",
        "Entrenador de Fútbol Infantil",
        "Entrenador de Fútbol Femenino"
      ],
      highlights: [
        {
          title: "Experiencia Educativa Superior",
          description: "Desempeño en diversas instituciones de educación superior"
        },
        {
          title: "Especialista en Fútbol Formativo",
          description: "Entrenador certificado en fútbol infantil y femenino"
        }
      ]
    }
  ],
  description: "Una guía completa para entrenadores de fútbol noveles que desean construir una marca personal sólida, auténtica y profesional. Este libro te enseña que en el fútbol moderno, las habilidades técnicas no son suficientes: necesitas cultivar una identidad profesional fuerte, una reputación impecable y una estrategia de comunicación efectiva.",
  targetAudience: [
    {
      title: "Graduados de instituciones de coaching",
      description: "Recién egresados de academias y programas de formación que inician su carrera profesional"
    },
    {
      title: "Entrenadores jóvenes",
      description: "Coaches en las primeras etapas de su trayectoria profesional buscando diferenciarse"
    },
    {
      title: "Entrenadores de base",
      description: "Profesionales trabajando en fútbol formativo, comunitario o amateur con aspiraciones de crecimiento"
    },
    {
      title: "Aspirantes al coaching",
      description: "Cualquier persona que desee ingresar a la profesión del entrenamiento deportivo con bases sólidas"
    }
  ],
  benefits: [
    {
      title: "Define tu identidad profesional",
      description: "Descubre tu vocación, fortalezas y propuesta de valor única como entrenador"
    },
    {
      title: "Construye reputación y credibilidad",
      description: "Aprende a generar confianza a través de acciones consistentes y comportamiento ético"
    },
    {
      title: "Desarrolla liderazgo efectivo",
      description: "Domina diferentes estilos de liderazgo y mejora tu imagen como líder inspirador"
    },
    {
      title: "Gestiona tu presencia digital",
      description: "Establece una presencia profesional online estratégica y efectiva"
    },
    {
      title: "Comunica tu historia",
      description: "Articula tu trayectoria, filosofía y propuesta de manera clara y convincente"
    },
    {
      title: "Impulsa tu empleabilidad",
      description: "Entiende el mercado laboral del fútbol y cómo posicionarte para mejores oportunidades"
    }
  ],
  chapters: [
    {
      number: 1,
      title: "¿Qué es el Personal Branding en el contexto del Entrenamiento de Fútbol?",
      description: "Fundamentos de la marca personal y su importancia en el fútbol moderno"
    },
    {
      number: 2,
      title: "La Identidad Profesional del Futuro Entrenador",
      description: "Aspectos internos de la marca personal: vocación, carácter e historia personal"
    },
    {
      number: 3,
      title: "Propuesta de Valor del Entrenador Graduado",
      description: "Cómo elaborar una propuesta de valor clara y diferenciada"
    },
    {
      number: 4,
      title: "Reputación, Credibilidad y Confianza",
      description: "Construcción de reputación y las tres dimensiones de la credibilidad"
    },
    {
      number: 5,
      title: "Liderazgo e Imagen del Entrenador",
      description: "Estilos de liderazgo y su impacto en la percepción profesional"
    },
    {
      number: 6,
      title: "Comunicación Profesional y Narrativa Personal",
      description: "Herramientas para comunicar efectivamente tu identidad profesional"
    },
    {
      number: 7,
      title: "Personal Branding y el Entorno Digital",
      description: "Presencia online, plataformas clave y directrices para publicar contenido"
    },
    {
      number: 8,
      title: "Ética, Conducta y Responsabilidad Pública",
      description: "Principios éticos fundamentales al trabajar con deportistas jóvenes"
    },
    {
      number: 9,
      title: "Personal Branding, Empleabilidad y Oportunidades",
      description: "Funcionamiento del mercado laboral y estrategias de posicionamiento"
    },
    {
      number: 10,
      title: "El Portafolio Profesional del Entrenador",
      description: "Componentes y construcción de un portafolio profesional efectivo"
    },
    {
      number: 11,
      title: "Posicionamiento Inicial del Entrenador Novel",
      description: "Primeros pasos cruciales después de la graduación"
    },
    {
      number: 12,
      title: "Casos Aplicados y Perfiles",
      description: "Estudios de caso de entrenadores con diferentes fortalezas y desafíos"
    },
    {
      number: 13,
      title: "Plan de Desarrollo de Marca Personal",
      description: "Metodología estructurada para crear tu plan de desarrollo profesional"
    }
  ],
  quotes: [
    {
      text: "Tu marca personal no es lo que dices que eres, sino lo que los demás perciben de ti a través de tus acciones consistentes.",
      context: "Sobre la autenticidad"
    },
    {
      text: "En el fútbol moderno, las habilidades técnicas no son suficientes. Necesitas cultivar una identidad profesional fuerte y una estrategia de comunicación efectiva.",
      context: "El nuevo paradigma del coaching"
    },
    {
      text: "La reputación es un activo valioso pero frágil que se construye con acciones positivas consistentes y puede dañarse rápidamente con errores o comportamiento no ético.",
      context: "Sobre la reputación"
    },
    {
      text: "El impacto que un entrenador tiene en las personas es la medida definitiva de su carrera.",
      context: "Legado profesional"
    }
  ],
  features: [
    "Ejercicios prácticos de autoevaluación",
    "Cuaderno de desarrollo personal incluido",
    "Casos de estudio realistas",
    "Plantillas y herramientas aplicables",
    "Plan de desarrollo para los primeros 90 días"
  ]
};

// Mock de suscriptores (simulación de base de datos)
export const mockSubscribers = [];

// Mock function para simular suscripción
export const mockSubscribe = (email, name) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      mockSubscribers.push({
        email,
        name,
        subscribedAt: new Date().toISOString()
      });
      resolve({ success: true, message: 'Suscripción exitosa' });
    }, 1000);
  });
};

// Mock function para simular descarga
export const mockDownloadSample = (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ 
        success: true, 
        message: 'Muestra enviada a tu correo',
        downloadUrl: '#' // En producción, aquí iría la URL real del PDF
      });
    }, 1500);
  });
};

// Mock function para formulario de contacto
export const mockContactSubmit = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ 
        success: true, 
        message: 'Mensaje enviado correctamente. Te contactaremos pronto.'
      });
    }, 1000);
  });
};
